export default __webpack_public_path__ + "static/media/benefit1.cd0aa3b7.png";